import { useEffect, useState } from 'react';
import { useLocalization } from '@/hooks/useLocalization';
import { useWidget } from '@/state/WidgetContext';
import { eventsService } from '@/services/events';
import styles from '@/styles/events.module.scss';

export default function EventDetailScreen() {
  const { t } = useLocalization();
  const { state } = useWidget();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    if (!state.selectedEventId) return;
    eventsService.getById(state.selectedEventId).then(setEvent);
  }, [state.selectedEventId]);

  if (!event) return null;

  return (
    <div className={styles.detail}>
      <div className={styles.detailBody}>
        <h2 className={styles.detailTitle}>
          {event.title}
          {event.is_top_event && <span className={styles.badge}>Top</span>}
        </h2>

        {event.description && (
          <p className={styles.detailDesc}>{event.description}</p>
        )}

        {event.date && (
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>{t('eventDetail.date')}</span>
            <span className={styles.detailValue}>{event.date}</span>
          </div>
        )}

        {event.location && (
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>{t('eventDetail.location')}</span>
            <span className={styles.detailValue}>{event.location}</span>
          </div>
        )}

        {event.url && (
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>{t('eventDetail.link')}</span>
            <a
              className={styles.detailLink}
              href={event.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('eventDetail.openLink')}
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
